import { X } from 'lucide-react';
import { TrashPanel } from './TrashPanel';

export function TrashDialog({ onClose }: { onClose: () => void }) {
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div
        className="w-full max-w-2xl bg-white rounded-xl shadow-2xl overflow-hidden max-h-[80vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-3.5 border-b border-zinc-100 flex-shrink-0">
          <div className="flex items-center gap-2">
            <span className="text-[14px] font-semibold text-zinc-900">回收站</span>
          </div>
          <button onClick={onClose} className="w-7 h-7 rounded-md flex items-center justify-center text-zinc-400 hover:bg-zinc-100 hover:text-zinc-700 transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex-1 overflow-hidden p-5">
          <TrashPanel showTitle={false} />
        </div>
      </div>
    </div>
  );
}
